import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";

import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { showToast } from "../ToastManager";
import { Checkbox } from "primereact/checkbox";
import { AutoComplete } from "primereact/autocomplete";

import Utils from "../../utilities/Utils";

import EmpresaService from "../../service/EmpresaService";
import EnderecoService from "../../service/EnderecoService";

const empresaService = new EmpresaService();
const enderecoService = new EnderecoService();


const CadastrarEmpresa = () => {
    const iss = localStorage.getItem('iss');
    const history = useHistory();

    let empresaNovo = {
        name: '',
        cnpj: '',
        razaoSocial: '',
        telefone: '',
        endereco: '',
        cidade: '',
        estado: '',
        cep: '',
    };

    const [empresa, setEmpresa] = useState(empresaNovo);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [todasCidades, setTodasCidades] = useState([]);
    const [cidades, setCidades] = useState([]);
    const [estados, setEstados] = useState([]);
    const [cidadesFilteredValue, setCidadesFilteredValue] = useState([]);
    const [estadosFilteredValue, setEstadosFilteredValue] = useState([]);
    const [cidade, setCidade] = useState(null);
    const [estado, setEstado] = useState(null);

    const { id } = useParams();

    useEffect(() => {

        if (id != null) {
            setLoading(true);
            empresaService.getEmpresa(iss, id).then(data => {
                setLoading(false);
                empresaNovo = data.data.rows[0];

                setTimeout(() => {

                    setEmpresa(empresaNovo);
                }, 200);

            });
        }
    }, []); //

    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';
        if (checkbox) {
            val = e.checked;
        }

        if (name === 'cnpj') {
            let c = String(val).replace(/[^\d]/g, '')
            if (c.length == 14 && !Utils.validaCNPJ(c)) {
                console.log(val);
                showToast({ severity: 'error', summary: 'Error', detail: 'CNPJ inválido' });
                return;
            }

            val = Utils.formatCnpj(val);
        }

        let _empresa = { ...empresa };
        // Verifica se o nome tem um ponto
        if (name.includes('.')) {
            const [parent, child] = name.split('.'); // Divide o nome em pai e filho
            if (!_empresa[parent]) {
                _empresa[parent] = {}; // Cria o objeto pai se não existir
            }
            _empresa[parent][child] = val; // Define o valor do atributo filho
        } else {
            if (list) {
                _empresa[name] = val;
            } else {
                _empresa[name] = val; // Define o valor diretamente se não houver aninhamento
            }

        }

        setEmpresa(_empresa);

    }

    function removeDuplicatesById(arr) {
        const idCounts = new Map();

        // Count occurrences of each id
        arr.forEach(item => {
            if (idCounts.has(item.id)) {
                idCounts.set(item.id, idCounts.get(item.id) + 1);
            } else {
                idCounts.set(item.id, 1);
            }
        });

        // Filter out items with duplicate ids
        return arr.filter(item => idCounts.get(item.id) === 1);
    }

    const cadastrar = () => {
        setSubmitted(true);
        if (empresa.name && empresa.razaoSocial && empresa.telefone && empresa.cep && empresa.endereco && empresa.cidade && empresa.estado) {
            let _empresa = { ...empresa };
            _empresa.cnpj = String(empresa.cnpj).replace(/[^\d]/g, '')
            setLoading(true)

            if (empresa.id != null) {
                empresaService.putEmpresa(iss, _empresa, empresa.id).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de empresa', detail: 'Empresa editada com sucesso' });
                    history.push('/empresa/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar empresa' });
                }).finally(() => { setLoading(false) });
            } else {
                empresaService.postEmpresa(iss, _empresa).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de empresa', detail: 'Empresa cadastrada com sucesso' });
                    history.push('/empresa/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            }


        } else {
            showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: 'Preencha todos os campos' });
        }

    }

    const searchCidade = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length) {
                setCidadesFilteredValue([...cidades]);
            }
            else {
                setCidadesFilteredValue(cidades.filter((cidade) => {
                    return cidade.nome.toLowerCase().includes(event.query.toLowerCase());
                }));
            }
        }, 250);
    }

    const searchEstado = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length) {
                setEstadosFilteredValue([...estados]);
            }
            else {
                setEstadosFilteredValue(estados.filter((estado) => {
                    return estado.nome.toLowerCase().includes(event.query.toLowerCase()) || estado.name.toLowerCase().includes(event.query.toLowerCase());
                }));
            }
        }, 250);
    }

    const handleKeyDown = (event, name) => {
        const { key } = event;
        const lastValue = empresa[name] || '';
        let _empresa = { ...empresa };
        if (key === 'Backspace') {
            const input = event.target;
            let cursorPos = input.selectionStart;
            if (cursorPos > 0 && (input.value[cursorPos - 1] === '.' || input.value[cursorPos - 1] === '-')) {
                event.preventDefault(); // Prevent default to manually handle backspace
                let newValue = lastValue.substring(0, cursorPos - 1) + lastValue.substring(cursorPos);
                newValue = newValue.replace(/\D/g, '');
                _empresa.cnpj = Utils.formatCnpj(newValue); // Apply mask after removal
                setEmpresa(_empresa);
            }
        }
    };

    const searchByCep = (cep) => {
        if (cep.length === 9) {
            enderecoService.getEnderecoPorCEP(cep).then(data => {
                let endereco = data.data;
                console.log(endereco);
                let _empresa = { ...empresa };
                //_empresa.logradouro = endereco.logradouro ? endereco.logradouro.toUpperCase() : "";
                // _empresa.bairro = endereco.bairro ? endereco.bairro.toUpperCase() : "";
                _empresa.endereco = endereco.logradouro ? endereco.logradouro.toUpperCase() + ", " : "";
                _empresa.endereco = _empresa.endereco + (endereco.bairro ? endereco.bairro.toUpperCase() : "");
                _empresa.cidade = endereco.localidade ? endereco.localidade.toUpperCase() : "";
                _empresa.estado = endereco.uf ? endereco.uf.toUpperCase() : "";
                // _empresa.complemento = endereco.complemento ? endereco.complemento.toUpperCase() : "";
                setEmpresa(_empresa);
            }, error => {
                showToast({ severity: 'error', summary: 'Erro ao buscar endereço', detail: 'Erro ao buscar endereço pelo cep' });

            });
        }
    }

    const verificaSeExisteCnpj = () => {
        let c = String(empresa.cnpj).replace(/[^\d]/g, '')
        if (c.length == 14 || c.length == 11) {
            setLoading(true);
            empresaService.getEmpresaPorCnpj(empresa.cnpj).then(data => {
                setLoading(false);
                if (data.status === 409) {
                    showToast({ severity: 'error', summary: 'Conflito', detail: 'CNPJ ou CPF já cadastrado' });
                }
            }, error => {
                setLoading(false);
                if (error.response.status === 409) {
                    showToast({ severity: 'error', summary: 'Conflito', detail: 'CNPJ ou CPF já cadastrado' });
                }

            });
        }
    };

    return (
        <div className="grid">
            <h4>Informações da empresa</h4>
            <div className="col-12">
                <div className="card">

                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText onBlur={() => verificaSeExisteCnpj()} onKeyDown={handleKeyDown} value={empresa.cnpj} onChange={(e) => onInputChange(e, 'cnpj')} required
                                    className={classNames({ 'p-invalid': submitted && !empresa.cnpj })} id="cnpj" type="text" />
                                <label htmlFor="cnpj">CNPJ</label>
                            </span>
                            {submitted && !empresa.cnpj && <small className="p-invalid">CNPJ é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText value={empresa.name} onChange={(e) => onInputChange(e, 'name')}
                                    className={classNames({ 'p-invalid': submitted && !empresa.name })} required id="name" type="text" />
                                <label htmlFor="name">Nome fantasia</label>
                            </span>
                            {submitted && !empresa.name && <small className="p-invalid">Nome é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12">
                            <span className="p-float-label">
                                <InputText value={empresa.razaoSocial} onChange={(e) => onInputChange(e, 'razaoSocial')}
                                    className={classNames({ 'p-invalid': submitted && !empresa.razaoSocial })} required id="razaoSocial" type="text" />
                                <label htmlFor="razaoSocial">Nome</label>
                            </span>
                            {submitted && !empresa.razaoSocial && <small className="p-invalid">Nome é obrigatório.</small>}
                        </div>

                        <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <InputMask value={empresa.telefone}
                                    onChange={(e) => onInputChange(e, 'telefone')}
                                    mask={"(99) 9999-9999"}
                                    id="telefone" type="text" />
                                <label htmlFor="telefone">Telefone</label>
                            </span>
                        </div>

                        <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <InputMask value={empresa.cep} onChange={(e) => {
                                    onInputChange(e, 'cep')
                                }}
                                    onBlur={(e) => searchByCep(e.target.value)}
                                    className={classNames({ 'p-invalid': submitted && !empresa.cep })} required
                                    mask="99999-999" id="cep" type="text" />
                                <label htmlFor="cep">CEP</label>
                            </span>
                            {submitted && !empresa.cep && <small className="p-invalid">Cep é obrigatório.</small>}
                        </div>

                        <div style={{ marginTop: 10 }} className="field col-12 md:col-8">
                            <span className="p-float-label">
                                <InputText value={empresa.endereco} onChange={(e) => onInputChange(e, 'endereco')}
                                    className={classNames({ 'p-invalid': submitted && !empresa.endereco })} required
                                    id="endereco" type="text" disabled />
                                <label htmlFor="endereco">Endereço</label>
                            </span>
                            {submitted && !empresa.endereco && <small className="p-invalid">Endereco é obrigatório.</small>}
                        </div>

                        <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                            <span className="p-float-label">

                                <AutoComplete value={empresa.cidade} onChange={(e) => onInputChange(e, 'endereco.cidade')}
                                    className={classNames({ 'p-invalid': submitted && !empresa.cidade })}
                                    placeholder="" id="cidade" dropdown
                                    suggestions={cidadesFilteredValue} completeMethod={searchCidade}
                                    field="nome" forceSelection disabled />
                                <label htmlFor="cidade">Cidade</label>
                            </span>
                            {submitted && !empresa.cidade && <small className="p-invalid">Cidade é obrigatório.</small>}
                        </div>

                        <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                            <span className="p-float-label">

                                <AutoComplete placeholder="" id="estado" dropdown
                                    value={empresa.estado} onChange={(e) => onInputChange(e, 'estado')}
                                    className={classNames({ 'p-invalid': submitted && !empresa.estado })} suggestions={estadosFilteredValue} completeMethod={searchEstado}
                                    field="nome" forceSelection disabled />
                                <label htmlFor="estado">Estado</label>
                            </span>
                            {submitted && !empresa.estado && <small className="p-invalid">Estado é obrigatório.</small>}
                        </div>

                        <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarEmpresa, comparisonFn);
